import Cropper from 'cropperjs';

angular.module('TetherApp').controller('GiftWithPurchaseController', [
    '$q',
    '$anchorScroll',
    '$location',
    '$window',
    '$timeout',
    '$interval',
    'Upload',
    'giftWithPurchaseService',
    'giftWithPurchasePrizingService',
    'experienceService',
    'participantModalService',
    'noteService',
    '$mdDialog',
    '$mdToast',
    'modelLockService',
    function (
        $q,
        $anchorScroll,
        $location,
        $window,
        $timeout,
        $interval,
        Upload,
        giftWithPurchaseService,
        giftWithPurchasePrizingService,
        experienceService,
        participantModalService,
        noteService,
        $mdDialog,
        $mdToast,
        modelLockService
    ) {
        let self = this;
        let redirectTo = '/experience/gift-with-purchase';

        self.isSubmitting = false;
        self.isLoading = true;

        self.giftWithPurchaseList = {};
        self.newToken = {};
        self.newTokenErrors = {};
        self.giftWithPurchase = {};
        self.participatingProducts = [];
        self.giftWithPurchase.experience = {};
        self.giftWithPurchase.experience.is_visible_on_campaign_dashboard = true;
        self.giftWithPurchase.experience.is_products_visible_on_dashboard = false;
        self.giftWithPurchase.experience.is_retailer_visible_on_dashboard = false;
        self.giftWithPurchase.coming_soon_started_at = new Date();
        self.giftWithPurchase.coming_soon_started_at.setMonth(self.giftWithPurchase.coming_soon_started_at.getMonth() - 1);
        self.giftWithPurchase.coming_soon_started_at.setHours(0);
        self.giftWithPurchase.coming_soon_started_at.setMinutes(0);
        self.giftWithPurchase.coming_soon_started_at.setSeconds(0);
        self.giftWithPurchase.coming_soon_started_at_hour = 0;
        self.giftWithPurchase.coming_soon_started_at_minute = 0;
        self.giftWithPurchase.coming_soon_started_at_second = 0;
        self.giftWithPurchase.closed_ended_at = new Date();
        self.giftWithPurchase.closed_ended_at.setMonth(self.giftWithPurchase.closed_ended_at.getMonth() + 1);
        self.giftWithPurchase.closed_ended_at.setHours(0);
        self.giftWithPurchase.closed_ended_at.setMinutes(0);
        self.giftWithPurchase.closed_ended_at.setSeconds(0);
        self.giftWithPurchase.closed_ended_at_hour = 23;
        self.giftWithPurchase.closed_ended_at_minute = 59;
        self.giftWithPurchase.closed_ended_at_second = 59;
        self.giftWithPurchase.started_at = new Date();
        self.giftWithPurchase.started_at.setHours(0);
        self.giftWithPurchase.started_at.setMinutes(0);
        self.giftWithPurchase.started_at.setSeconds(0);
        self.giftWithPurchase.started_at_hour = 0;
        self.giftWithPurchase.started_at_minute = 0;
        self.giftWithPurchase.started_at_second = 0;
        self.giftWithPurchase.ended_at = new Date();
        self.giftWithPurchase.ended_at.setHours(0);
        self.giftWithPurchase.ended_at.setMinutes(0);
        self.giftWithPurchase.ended_at.setSeconds(0);
        self.giftWithPurchase.ended_at_hour = 23;
        self.giftWithPurchase.ended_at_minute = 59;
        self.giftWithPurchase.ended_at_second = 59;

        // Profile Closed At
        self.giftWithPurchase.profile_closed_at = new Date();
        self.giftWithPurchase.profile_closed_at.setHours(0);
        self.giftWithPurchase.profile_closed_at.setMinutes(0);
        self.giftWithPurchase.profile_closed_at.setSeconds(0);
        self.giftWithPurchase.profile_closed_at_hour = 23;
        self.giftWithPurchase.profile_closed_at_minute = 59;
        self.giftWithPurchase.profile_closed_at_second = 59;
        ///

        self.giftWithPurchase.visibility = 'public';
        self.giftWithPurchase.requires_validation = false;
        self.giftWithPurchase.private_list = 'Private List';
        self.giftWithPurchase.limit_type = 'unlimited';
        self.giftWithPurchase.limit_count = 1;
        self.giftWithPurchase.limit_by = 0; // phone
        self.giftWithPurchase.entry_scheduling = 'daily';
        self.giftWithPurchase.deliver_by = 'sms';
        self.giftWithPurchase.has_language_gate = false;
        self.giftWithPurchase.tokens = [];
        self.editingTokens = {};
        self.giftWithPurchase.pages = [
            {
                'name': 'Home',
                'html': '',
            },
            {
                'name': 'Home FR',
                'html': '',
            },
            {
                'name': 'Entry',
                'html': '',
            },
            {
                'name': 'Entry FR',
                'html': '',
            },
            {
                'name': 'Register',
                'html': '',
            },
            {
                'name': 'Register FR',
                'html': '',
            },
            {
                'name': 'Login',
                'html': '',
            },
            {
                'name': 'Login FR',
                'html': '',
            },
            {
                'name': 'Coupon',
                'html': '',
            },
            {
                'name': 'Coupon FR',
                'html': '',
            },
            {
                'name': 'Profile',
                'html': '',
            },
            {
                'name': 'Profile FR',
                'html': '',
            },
            {
                'name': 'FAQ',
                'html': '',
            },
            {
                'name': 'FAQ FR',
                'html': '',
            },
            {
                'name': 'Support',
                'html': '',
            },
            {
                'name': 'Support FR',
                'html': '',
            },
            {
                'name': 'Alternative Entry',
                'html': '',
            },
            {
                'name': 'Alternative Entry FR',
                'html': '',
            },
            {
                'name': 'Terms',
                'html': '',
            },
            {
                'name': 'Terms FR',
                'html': '',
            },
            {
                'name': 'Privacy',
                'html': '',
            },
            {
                'name': 'Privacy FR',
                'html': '',
            },
            {
                'name': 'Closed',
                'html': '',
            },
            {
                'name': 'Closed FR',
                'html': '',
            },
            {
                'name': 'Opening Soon',
                'html': '',
            },
            {
                'name': 'Opening Soon FR',
                'html': '',
            },
            {
                'name': 'Confirmation',
                'html': '',
            },
            {
                'name': 'Confirmation FR',
                'html': '',
            },
            {
                'name': 'Access',
                'html': '',
            },
            {
                'name': 'Access FR',
                'html': '',
            },
            {
                'name': 'Language',
                'html': '',
            },
            {
                'name': 'Language FR',
                'html': '',
            },
            {
                'name': 'Claim',
                'html': '',
            },
            {
                'name': 'Claim FR',
                'html': '',
            },
            {
                'name': 'No Purchase PDF',
                'html': '',
            },
            {
                'name': 'No Purchase PDF FR',
                'html': '',
            },
            {
                'name': 'Winners',
                'html': '',
            },
            {
                'name': 'Winners FR',
                'html': '',
            },
            {
                'name': 'Prizes',
                'html': '',
            },
            {
                'name': 'Prizes FR',
                'html': '',
            },
            {
                'name': 'CSS',
                'html': '',
            }
        ];
        self.editingPages = {};

        self.giftWithPurchase.form_rules = [];
        self.giftWithPurchase.participating_product = [];
        self.client_products = [];
        self.selected_product = {};
        self.formRulesArray = [
            'Entry',
            'Alternative Entry',
            'Claim',
            'Offline',
            'Register',
            'Profile'
        ];
        self.editingFormRules = [];
        self.newFormRule = {};

        self.limits = range(1, 100);
        self.hours = range(0, 23);
        self.minutes = range(0, 59);
        self.seconds = range(0, 59);
        self.currentPage = 1;
        self.isRedirect = false;
        self.currentEntryImageMd5Hashes = [];
        self.otherEntriesImageMd5Hashes = {};

        // REPORTING
        self.stats = {};
        self.graph = {};
        self.reportingStartedAt = undefined;
        self.reportingEndedAt = undefined;

        self.winnerFrom = new Date();
        self.winnerFrom.setHours(0);
        self.winnerFrom.setMinutes(0);
        self.winnerFrom.setSeconds(0);
        self.winnerFromHour = 0;
        self.winnerFromMinute = 0;
        self.winnerTo = new Date();
        self.winnerTo.setHours(0);
        self.winnerTo.setMinutes(0);
        self.winnerTo.setSeconds(0);
        self.winnerToHour = 0;
        self.winnerToMinute = 0;
        self.selectedWinnerParticipants = [];
        self.winnerRules = [];
        self.prizePools = {};
        self.prizePool = '';
        // self.modalOpen = true;

        // MD5
        self.imageMd5Hashes = {};
        self.currentEntryImageMd5Hashes = {};
        self.otherEntriesImageMd5Hashes = {};

        // image analysis temp
        self.submissionBanner = '';
        self.submissionProvince = '';
        self.submissionBrandsAndPackSizes = '';
        self.submissionQuantityOfQualifyingProducts = '';
        self.submissionTransactionDate = '';
        self.submissionTransactionTime = '';
        self.submissionTransactionPaymentType = '';
        self.submissionTransactionTotal = '';
        self.submissionRetailerName = '';
        self.submissionRetailerAddress1 = '';
        self.submissionRetailerAddress2 = '';
        self.submissionRetailerCity = '';
        self.submissionRetailerProvince = '';
        self.submissionRetailerPostalCode = '';

        //Rejection reasons
        self.languageRejectionReasons = {};
        self.newRejectionReasonName = '';

        //Model Lock
        self.modelLock;
        self.experienceLockTimeRemainingDisplay;
        self.experienceLockTimeEndDisplay;
        self.experienceLockCountdown = undefined;

        // START: FORM RULES
        self.areOptionsDisabled = false;

        self.checkForEnforcedRules = function (index) {
            if (self.newFormRule[index].field_name === 'g-recaptcha-response') {
                self.newFormRule[index].is_required = true;
                self.newFormRule[index].format = 'captcha';
                self.newFormRule[index].is_disabled = true;
                self.areOptionsDisabled = true;
            }
        };

        self.addToken = function () {
            self.newTokenErrors = {};

            if (! self.newToken.name) {
                self.newTokenErrors['name'] = 'The name field is required';
            }

            if (! self.newToken.key) {
                self.newTokenErrors['key'] = 'The key field is required';
            }

            if (! self.newToken.content) {
                self.newTokenErrors['content'] = 'The content field is required';
            }

            if (Object.keys(self.newTokenErrors).length === 0) {
                let tempToken = JSON.parse(JSON.stringify(self.newToken));

                self.giftWithPurchase.tokens.push(tempToken);

                self.newToken = {};
            }
        };

        self.removeToken = function (tokenIndex) {
            self.giftWithPurchase.tokens.splice(tokenIndex, 1);
        };

        self.isEditingToken = function (tokenIndex) {
            if (self.editingTokens[tokenIndex] === undefined) {
                self.editingTokens[tokenIndex] = {};
            }
            if (self.editingTokens[tokenIndex].isOpen === undefined) {
                self.editingTokens[tokenIndex].isOpen = true;
            } else {
                self.editingTokens[tokenIndex].isOpen = !self.editingTokens[tokenIndex].isOpen;
            }
        };

        self.addFormRule = function ($index, type) {
            // Copy object
            let tempFormRule = JSON.parse(JSON.stringify(self.newFormRule[$index]));

            // Set form rule type
            tempFormRule.type = type;

            // Set is required to string equivalent
            let isRequired = tempFormRule.is_required ? 'required' : 'nullable';

            // Create field rules string
            tempFormRule.field_rules = [isRequired, tempFormRule.format].join('|');

            // Remove no longer relevant properties
            delete tempFormRule.is_required;
            delete tempFormRule.format;

            // Add item to giftWithPurchase object
            self.giftWithPurchase.form_rules.push(tempFormRule);

            // Reset the form values
            self.newFormRule[$index] = {};
            self.areOptionsDisabled = false;
        };

        self.removeFormRule = function (currentFormRule) {
            self.giftWithPurchase.form_rules.forEach(function (formRule, key) {
                // if the passed form rule equals the current iteration
                // form rule, remove it from the array
                if (angular.equals(formRule, currentFormRule)) {
                    self.giftWithPurchase.form_rules.splice(key, 1);
                }
            });
        };

        self.formRuleForType = function (type) {
            let tempRules = [];

            self.giftWithPurchase.form_rules.forEach(function (formRule) {
                if (formRule.type == type) {
                    tempRules.push(formRule);
                }
            });

            return tempRules;
        };

        self.prettyFieldName = function (name) {
            return name.replace('_', ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        };

        self.prettyRules = function (name) {
            return name.replace('|', ', ')
                .replace(',FIXED_LINE_OR_MOBILE', '')
                .replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        };

        self.isEditingFormRule = function (index) {
            if (self.editingFormRules[index] == undefined) {
                self.editingFormRules[index] = true;
            } else {
                self.editingFormRules[index] = ! self.editingFormRules[index];
            }
        };
        // END: FORM RULES

        // START: UPLOAD QUESTIONS
        self.giftWithPurchase.uploaded_image_questions = [];
        self.newUploadedImageQuestion = { type : '' };
        self.newUploadedImageQuestionAnswer = '';
        self.existingUploadedImageQuestionAnswer = '';
        self.newUploadedImageQuestionField = '';
        self.existingUploadedImageQuestionField = '';
        self.isQuestionOpen = {};

        self.addUploadedImageQuestion = function (data) {
            // Copy object
            let tempUploadedImageQuestion = JSON.parse(JSON.stringify(self.newUploadedImageQuestion));

            // Add item to giftWithPurchase object
            self.giftWithPurchase.uploaded_image_questions.push(tempUploadedImageQuestion);

            // Reset the question values
            self.newUploadedImageQuestion = { type : '' };
        };

        self.removeUploadedImageQuestion = function (index) {
            self.giftWithPurchase.uploaded_image_questions.splice(index, 1);
        };

        self.addNewUploadedImageQuestionAnswer = function () {
            if (!self.newUploadedImageQuestion.hasOwnProperty('configuration')) {
                self.newUploadedImageQuestion.configuration = [];
            }
            self.newUploadedImageQuestion.configuration.push(self.newUploadedImageQuestionAnswer);
            self.newUploadedImageQuestionAnswer = '';
        };

        self.removeNewUploadedImageQuestionAnswer = function (index) {
            self.newUploadedImageQuestion.configuration.splice(index, 1);
        };

        self.addExistingUploadedImageQuestionAnswer = function (index) {
            if (!self.giftWithPurchase.uploaded_image_questions[index].hasOwnProperty('configuration')) {
                self.giftWithPurchase.uploaded_image_questions[index].configuration = [];
            }
            self.giftWithPurchase.uploaded_image_questions[index].configuration.push(self.existingUploadedImageQuestionAnswer);
            self.existingUploadedImageQuestionAnswer = '';
        };

        self.removeExistingUploadedImageQuestionAnswer = function (index, answerIndex) {
            self.giftWithPurchase.uploaded_image_questions[index].configuration.splice(answerIndex, 1);
        };

        self.addNewUploadedImageQuestionField = function () {
            if (!self.newUploadedImageQuestion.hasOwnProperty('configuration')) {
                self.newUploadedImageQuestion.configuration = [];
            }
            self.newUploadedImageQuestion.configuration.push({ type: 'text', name: self.newUploadedImageQuestionField });
            self.newUploadedImageQuestionField = '';
        };

        self.removeNewUploadedImageQuestionField = function (index) {
            self.newUploadedImageQuestion.configuration.splice(index, 1);
        };

        self.addExistingUploadedImageQuestionField = function (index) {
            if (!self.giftWithPurchase.uploaded_image_questions[index].hasOwnProperty('configuration')) {
                self.giftWithPurchase.uploaded_image_questions[index].configuration = [];
            }
            self.giftWithPurchase.uploaded_image_questions[index].configuration.push({ type: 'text', name: self.existingUploadedImageQuestionField });
            self.existingUploadedImageQuestionField = '';
        };

        self.removeExistingUploadedImageQuestionField = function (index, fieldIndex) {
            self.giftWithPurchase.uploaded_image_questions[index].configuration.splice(fieldIndex, 1);
        };

        self.toggleQuestionOpen = function (index) {
            self.isQuestionOpen[index] = !self.isQuestionOpen[index];
        };

        // END: UPLOAD QUESTIONS

        //START: INDEX SERVICE FUNCTIONS
        self.index = function (page) {
            self.currentPage = page;
            giftWithPurchaseService.indexGiftWithPurchase(self.currentPage)
                .then(onIndex, onError);
        };

        let onIndex = function (data) {
            self.giftWithPurchaseList = data.data;
            angular.forEach(self.giftWithPurchaseList, function(gwp){
                giftWithPurchaseService.showGiftWithPurchase(gwp.id)
                    .then(onListItemLoad, onError);
            });
        };

        self.perPageChanged = function () {
            let form = window.document.querySelector('form#query_form');
            if (form) {
                $timeout(function () {
                    form.submit();
                });
            }
        };
        //END: INDEX SERVICE FUNCTIONS

        let onListItemLoad = function (data) {
            angular.forEach(self.giftWithPurchaseList, function(gwp) {
                if(gwp.id == data.experience.id) {
                    if(data.requires_validation == 1) {
                        gwp.requiresValidation = true;
                    }
                }
            });
        };

        self.show = function (unparsed) {
            let data = unparsed;

            self.currentSetPages = self.giftWithPurchase.pages;
            self.giftWithPurchase.tokens = data.tokens;

            data.has_sharing = (data.has_sharing == '1') ? true : false;
            data.has_language_gate = (data.has_language_gate == '1') ? true : false;
            data.has_optin = (data.has_optin == '1') ? true : false;
            data.has_separate_optin_message = (data.has_separate_optin_message == '1') ? true : false;
            data.is_secret_code_experience = (data.is_secret_code_experience == '1') ? true : false;
            data.requires_validation = (data.requires_validation == '1') ? true : false;
            data.has_login = (data.has_login == '1') ? true : false;
            data.use_credits_by_prize_pool = (data.use_credits_by_prize_pool == '1') ? true : false;
            data.has_per_household_check = (data.has_per_household_check == '1') ? true : false;
            data.has_consumer_redemption = (data.has_consumer_redemption == '1') ? true : false;

            data.started_at = new Date(data.started_at.replace(/-/g, "/"));
            data.ended_at = new Date(data.ended_at.replace(/-/g, "/"));

            if (data.hasOwnProperty('coming_soon_started_at') && data.coming_soon_started_at) {
                data.coming_soon_started_at = new Date(data.coming_soon_started_at.replace(/-/g, "/"));
            } else {
                data.coming_soon_started_at = data.started_at ? new Date(JSON.parse(JSON.stringify(data.started_at))) : new Date();
                data.coming_soon_started_at.setMonth(data.coming_soon_started_at.getMonth() - 1);
                data.coming_soon_started_at.setHours(0);
                data.coming_soon_started_at.setMinutes(0);
                data.coming_soon_started_at.setSeconds(0);
            }
            if (data.hasOwnProperty('closed_ended_at') && data.closed_ended_at) {
                data.closed_ended_at = new Date(data.closed_ended_at.replace(/-/g, "/"));
            } else {
                data.closed_ended_at = data.ended_at ? new Date(JSON.parse(JSON.stringify(data.ended_at))) : new Date();
                data.closed_ended_at.setMonth(data.closed_ended_at.getMonth() + 1);
                data.closed_ended_at.setHours(23);
                data.closed_ended_at.setMinutes(59);
                data.closed_ended_at.setSeconds(50);
            }

            if (data.hasOwnProperty('profile_closed_at') && data.profile_closed_at) {
                data.profile_closed_at = new Date(data.profile_closed_at.replace(/-/g, "/"));
            }

            angular.forEach(data.pages, function(currentLoadedPage) {
                angular.forEach(self.currentSetPages, function(currentSetPage, key) {
                    if(currentSetPage.name === currentLoadedPage.name) {
                        self.currentSetPages[key] = currentLoadedPage;
                    }
                });
            });

            data.pages = self.currentSetPages;

            self.giftWithPurchase = data;
            self.giftWithPurchase.coming_soon_started_at_hour = data.coming_soon_started_at.getHours();
            self.giftWithPurchase.coming_soon_started_at_minute = data.coming_soon_started_at.getMinutes();
            self.giftWithPurchase.coming_soon_started_at_second = data.coming_soon_started_at.getSeconds();
            self.giftWithPurchase.closed_ended_at_hour = data.closed_ended_at.getHours();
            self.giftWithPurchase.closed_ended_at_minute = data.closed_ended_at.getMinutes();
            self.giftWithPurchase.closed_ended_at_second = data.closed_ended_at.getSeconds();
            self.giftWithPurchase.started_at_hour = data.started_at.getHours();
            self.giftWithPurchase.started_at_minute = data.started_at.getMinutes();
            self.giftWithPurchase.started_at_second = data.started_at.getSeconds();
            self.giftWithPurchase.ended_at_hour = data.ended_at.getHours();
            self.giftWithPurchase.ended_at_minute = data.ended_at.getMinutes();
            self.giftWithPurchase.ended_at_second = data.ended_at.getSeconds();

            // Profile Closed At
            if (data.profile_closed_at) {
                self.giftWithPurchase.profile_closed_at_hour = data.profile_closed_at.getHours();
                self.giftWithPurchase.profile_closed_at_minute = data.profile_closed_at.getMinutes();
                self.giftWithPurchase.profile_closed_at_second = data.profile_closed_at.getSeconds();
            }

            if (self.giftWithPurchase.private_list == null || self.giftWithPurchase.private_list == undefined) {
                self.giftWithPurchase.private_list = 'Private List';
            }

            if (self.giftWithPurchase.limit_count == null || self.giftWithPurchase.limit_count == undefined) {
                self.giftWithPurchase.limit_count = 1;
            }

            if (self.giftWithPurchase.max_valid_entries_count == null || self.giftWithPurchase.max_valid_entries_count == undefined) {
                self.giftWithPurchase.max_valid_entries_count = '';
            }

            if (self.giftWithPurchase.awarded_prize_limit == null || self.giftWithPurchase.awarded_prize_limit == undefined) {
                self.giftWithPurchase.awarded_prize_limit = '';
            }

            if (! self.giftWithPurchase.hasOwnProperty('form_rules')) {
                self.giftWithPurchase.form_rules = [];
            }

            if (! self.giftWithPurchase.hasOwnProperty('uploaded_image_questions')) {
                self.giftWithPurchase.uploaded_image_questions = [];
            }

            // PUT THIS IN AN IFF BLOCK LIKE ABOVE
            if (self.giftWithPurchase.hasOwnProperty('experience_products')) {
                for (let clientProduct of self.client_products) {
                    if (clientProduct.eid in self.giftWithPurchase['experience_products']) {
                        self.participatingProducts.push(
                            {
                                eid: clientProduct.eid,
                                name: clientProduct.name,
                                alias: {
                                    en: self.giftWithPurchase['experience_products'][clientProduct.eid].alias_en,
                                    fr: self.giftWithPurchase['experience_products'][clientProduct.eid].alias_fr
                                },
                                show: false
                            }
                        );
                    }
                }
            }
            self.awardThreshold = self.giftWithPurchase.award_credit_threshold;

            angular.forEach(self.giftWithPurchase.rejection_reason, function(currentRejectionReason, index) {
                self.languageRejectionReasons[index] = {};
                self.languageRejectionReasons[index].show = false;
                self.giftWithPurchase.rejection_reason[index].is_rejected_due_to_prize_limit_rejection_reason
                    = (self.giftWithPurchase.rejection_reason[index].is_rejected_due_to_prize_limit_rejection_reason == '1') ? true : false;
            });
            self.getExperienceLock();
        };
        //END: SHOW SERVICE FUNCTIONS

        //START: STORE SERVICE FUNCTIONS
        self.store = function (isRedirect) {
            let tempGiftWithPurchase = JSON.parse(JSON.stringify(self.giftWithPurchase));

            if (!isRedirect === false) {
                self.isRedirect = true;
                tempGiftWithPurchase.isRedirect = true;
            }
            if (self.isSubmitting == false) {
                self.isSubmitting = true;

                tempGiftWithPurchase.coming_soon_started_at = new Date(
                    self.giftWithPurchase.coming_soon_started_at.getFullYear(),
                    self.giftWithPurchase.coming_soon_started_at.getMonth(),
                    self.giftWithPurchase.coming_soon_started_at.getDate(),
                    self.giftWithPurchase.coming_soon_started_at_hour,
                    self.giftWithPurchase.coming_soon_started_at_minute,
                    self.giftWithPurchase.coming_soon_started_at_second
                );

                tempGiftWithPurchase.closed_ended_at = new Date(
                    self.giftWithPurchase.closed_ended_at.getFullYear(),
                    self.giftWithPurchase.closed_ended_at.getMonth(),
                    self.giftWithPurchase.closed_ended_at.getDate(),
                    self.giftWithPurchase.closed_ended_at_hour,
                    self.giftWithPurchase.closed_ended_at_minute,
                    self.giftWithPurchase.closed_ended_at_second
                );

                tempGiftWithPurchase.started_at = new Date(
                    self.giftWithPurchase.started_at.getFullYear(),
                    self.giftWithPurchase.started_at.getMonth(),
                    self.giftWithPurchase.started_at.getDate(),
                    self.giftWithPurchase.started_at_hour,
                    self.giftWithPurchase.started_at_minute,
                    self.giftWithPurchase.started_at_second
                );

                tempGiftWithPurchase.ended_at = new Date(
                    self.giftWithPurchase.ended_at.getFullYear(),
                    self.giftWithPurchase.ended_at.getMonth(),
                    self.giftWithPurchase.ended_at.getDate(),
                    self.giftWithPurchase.ended_at_hour,
                    self.giftWithPurchase.ended_at_minute,
                    self.giftWithPurchase.ended_at_second
                );

                if (self.giftWithPurchase.profile_closed_at) {
                    tempGiftWithPurchase.profile_closed_at = new Date(
                        self.giftWithPurchase.profile_closed_at.getFullYear(),
                        self.giftWithPurchase.profile_closed_at.getMonth(),
                        self.giftWithPurchase.profile_closed_at.getDate(),
                        self.giftWithPurchase.profile_closed_at_hour,
                        self.giftWithPurchase.profile_closed_at_minute,
                        self.giftWithPurchase.profile_closed_at_second
                    );
                }

                if (tempGiftWithPurchase.hasOwnProperty('service_level_agreement_hours')
                    && (self.giftWithPurchase.service_level_agreement_hours === undefined
                        || self.giftWithPurchase.service_level_agreement_hours === null
                        || (typeof self.giftWithPurchase.service_level_agreement_hours === 'number' && self.giftWithPurchase.service_level_agreement_hours === 0))) {
                    tempGiftWithPurchase.service_level_agreement_hours = null;
                }

                if (self.participatingProducts.length != 0) {
                    tempGiftWithPurchase['experience_products'] = []
                    for (let product of self.participatingProducts) {
                        tempGiftWithPurchase['experience_products'].push({
                            'tether_product_eid': product.eid,
                            'alias_en': product.alias.en,
                            'alias_fr': product.alias.fr
                        });
                    }
                }

                giftWithPurchaseService.storeGiftWithPurchase(tempGiftWithPurchase)
                    .then(onStore, onError);
            }
        };

        let onStore = function (data) {
            redirectToIndex();
        };
        //END: STORE SERVICE FUNCTIONS

        //START: UPDATE SERVICE FUNCTIONS
        self.update = function (isRedirect) {
            let tempGiftWithPurchase = JSON.parse(JSON.stringify(self.giftWithPurchase));
            if (!isRedirect === false) {
                self.isRedirect = true;
            }
            if (self.isSubmitting == false) {
                self.isSubmitting = true;
                tempGiftWithPurchase.coming_soon_started_at = new Date(
                    self.giftWithPurchase.coming_soon_started_at.getFullYear(),
                    self.giftWithPurchase.coming_soon_started_at.getMonth(),
                    self.giftWithPurchase.coming_soon_started_at.getDate(),
                    self.giftWithPurchase.coming_soon_started_at_hour,
                    self.giftWithPurchase.coming_soon_started_at_minute,
                    self.giftWithPurchase.coming_soon_started_at_second
                );

                tempGiftWithPurchase.closed_ended_at = new Date(
                    self.giftWithPurchase.closed_ended_at.getFullYear(),
                    self.giftWithPurchase.closed_ended_at.getMonth(),
                    self.giftWithPurchase.closed_ended_at.getDate(),
                    self.giftWithPurchase.closed_ended_at_hour,
                    self.giftWithPurchase.closed_ended_at_minute,
                    self.giftWithPurchase.closed_ended_at_second
                );

                tempGiftWithPurchase.started_at = new Date(
                    self.giftWithPurchase.started_at.getFullYear(),
                    self.giftWithPurchase.started_at.getMonth(),
                    self.giftWithPurchase.started_at.getDate(),
                    self.giftWithPurchase.started_at_hour,
                    self.giftWithPurchase.started_at_minute,
                    self.giftWithPurchase.started_at_second
                );

                tempGiftWithPurchase.ended_at = new Date(
                    self.giftWithPurchase.ended_at.getFullYear(),
                    self.giftWithPurchase.ended_at.getMonth(),
                    self.giftWithPurchase.ended_at.getDate(),
                    self.giftWithPurchase.ended_at_hour,
                    self.giftWithPurchase.ended_at_minute,
                    self.giftWithPurchase.ended_at_second
                );

                if (self.giftWithPurchase.profile_closed_at) {
                    tempGiftWithPurchase.profile_closed_at = new Date(
                        self.giftWithPurchase.profile_closed_at.getFullYear(),
                        self.giftWithPurchase.profile_closed_at.getMonth(),
                        self.giftWithPurchase.profile_closed_at.getDate(),
                        self.giftWithPurchase.profile_closed_at_hour,
                        self.giftWithPurchase.profile_closed_at_minute,
                        self.giftWithPurchase.profile_closed_at_second
                    );
                }

                if (tempGiftWithPurchase.hasOwnProperty('service_level_agreement_hours')
                    && (self.giftWithPurchase.service_level_agreement_hours === undefined
                        || self.giftWithPurchase.service_level_agreement_hours === null
                        || (typeof self.giftWithPurchase.service_level_agreement_hours === 'number' && self.giftWithPurchase.service_level_agreement_hours === 0))) {
                    tempGiftWithPurchase.service_level_agreement_hours = null;
                }

                if (self.participatingProducts.length != 0) {
                    tempGiftWithPurchase['experience_products'] = []
                    for (let product of self.participatingProducts) {
                        tempGiftWithPurchase['experience_products'].push({
                            'tether_product_eid': product.eid,
                            'alias_en': product.alias.en,
                            'alias_fr': product.alias.fr
                        });
                    }
                }
                console.log(tempGiftWithPurchase);
                giftWithPurchaseService.updateGiftWithPurchase(tempGiftWithPurchase)
                    .then(onUpdate, onError);
            }
        };

        let onUpdate = function (data) {
            if (self.isRedirect) {       
                self.releaseExperienceLock();
                redirectToIndex();
            } else {
                self.extendExperienceLock();
                self.isSubmitting = false;
            }
        };
        //END: UPDATE SERVICE FUNCTIONS

        //START: DESTROY SERVICE FUNCTIONS
        self.delete = function (giftWithPurchaseId) {
            if ($window.confirm(self.deleteText.replace(':id', giftWithPurchaseId))) {
                giftWithPurchaseService.deleteGiftWithPurchase(giftWithPurchaseId)
                    .then(redirectToIndex, onError);
            }
        };

        let redirectToIndex = function () {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: DESTROY SERVICE FUNCTIONS

        //START: giftWithPurchase PAGES FUNCTIONS
        self.isEditing = function (tetherId) {
            if (self.editingPages[tetherId] == undefined) {
                self.editingPages[tetherId] = {};
            }
            if (self.editingPages[tetherId].isOpen == undefined) {
                self.editingPages[tetherId].isOpen = true;
            } else {
                self.editingPages[tetherId].isOpen = !self.editingPages[tetherId].isOpen;
            }
        };
        //END: giftWithPurchase PAGES FUNCTIONS

        //START: GENERAL SERVICE FUNCTIONS
        self.scrollToTop = function () {
            $location.hash('top');
            $anchorScroll();
        };

        let onError = function (data) {
            self.isSubmitting = false;
            self.isEntrySubmitting = false;
            $location.hash('top');
            $anchorScroll();
            self.errors = data.data.errors;
        };

        self.listNotes = function (participantId) {
            noteService.listNotes(participantId)
                .then(onListNotes, onError);
        };

        let onListNotes = function (data) {
            self.entryParticipantNotes = data;
        };

        self.openNotes = function (ev) {
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'noteModalController',
                bindToController: true,
                templateUrl: '/experience/gift-with-purchase/partials/note-modal',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };
        //END: GENERAL SERVICE FUNCTIONS

        //START: SWEEPS WINNER DRAWING

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };

            let onSend = function (data) {
                //
            };

            let onError = function (data) {
                //
            };

        };

        self.winnerPopup = function(ev, experienceId) {
            self.experienceId = experienceId;
            self.getPrizePools();
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'winnerPopupController',
                bindToController: true,
                templateUrl: '/experience/gift-with-purchase/partials/winner-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
        };

        self.drawWinners = function(){
            data = {};
            data.count = self.winnerCount;

            self.selectedWinnerParticipants = [];

            if (self.winnerFromHour != undefined && self.winnerFromHour != '') {
                self.winnerFromHour = parseInt(self.winnerFromHour);
                self.winnerFrom.setHours(self.winnerFromHour);
            }

            if (self.winnerFromMinute != undefined && self.winnerFromMinute != '') {
                self.winnerFromMinute = parseInt(self.winnerFromMinute);
                self.winnerFrom.setMinutes(self.winnerFromMinute);
            }

            if (self.winnerToHour != undefined && self.winnerToHour != '') {
                self.winnerToHour = parseInt(self.winnerToHour);
                self.winnerTo.setHours(self.winnerToHour);
            }

            if (self.winnerToMinute != undefined && self.winnerToMinute != '') {
                self.winnerToMinute = parseInt(self.winnerToMinute);
                self.winnerTo.setMinutes(self.winnerToMinute);
            }

            data.from = self.winnerFrom;
            data.to = self.winnerTo;
            data.rules = self.winnerRules;

            giftWithPurchaseService.drawWinners(self.experienceId, data)
                .then(onDrawWinners, onError);
        };

        let onDrawWinners = function (data) {
            self.participants = data;
            angular.forEach(self.participants, function(participant, key) {
                if(participant.data) {
                    participant.data = JSON.parse(participant.data);
                }
            });
        };

        self.selectAllWinners = function(){
            self.selectedWinnerParticipants = [];
            angular.forEach(self.participants, function(participant, key) {
                self.selectedWinnerParticipants.push(participant.id);
            });
        };

        self.redrawWinners = function(){
            data = {};
            data.count = self.selectedWinnerParticipants.length;

            if (self.winnerFromHour != undefined && self.winnerFromHour != '') {
                self.winnerFromHour = parseInt(self.winnerFromHour);
                self.winnerFrom.setHours(self.winnerFromHour);
            }

            if (self.winnerFromMinute != undefined && self.winnerFromMinute != '') {
                self.winnerFromMinute = parseInt(self.winnerFromMinute);
                self.winnerFrom.setMinutes(self.winnerFromMinute);
            }

            if (self.winnerToHour != undefined && self.winnerToHour != '') {
                self.winnerToHour = parseInt(self.winnerToHour);
                self.winnerTo.setHours(self.winnerToHour);
            }

            if (self.winnerToMinute != undefined && self.winnerToMinute != '') {
                self.winnerToMinute = parseInt(self.winnerToMinute);
                self.winnerTo.setMinutes(self.winnerToMinute);
            }

            data.from = self.winnerFrom;
            data.to = self.winnerTo;
            data.rules = self.winnerRules;

            giftWithPurchaseService.drawWinners(self.experienceId, data)
                .then(onRedrawWinners, onError);
        };

        let onRedrawWinners = function(data){
            participantsToKeep = [];

            angular.forEach(self.participants, function(participant, key) {
                if(self.selectedWinnerParticipants.indexOf(participant.id) === -1) {
                    participantsToKeep.push(participant);
                }
            });

            self.participants = participantsToKeep;

            self.selectedWinnerParticipants = [];

            tempParticipants = data;
            angular.forEach(tempParticipants, function(participant, key) {
                if(participant.data) {
                    participant.data = JSON.parse(participant.data);
                }
                self.participants.push(participant);
            });
        };

        self.confirmWinners = function(){
            data = {};
            data.participantIds = [];
            data.prizePool = self.prizePool;

            angular.forEach(self.selectedWinnerParticipants, function(value, key) {
                data.participantIds.push(value);
            });

            giftWithPurchaseService.confirmWinners(self.experienceId, data)
                .then(onConfirmWinners, onError);
        };

        let onConfirmWinners = function (data) {
            participantsToKeep = [];

            angular.forEach(self.participants, function(participant, key) {
                if(self.selectedWinnerParticipants.indexOf(participant.id) === -1) {
                    participantsToKeep.push(participant);
                }
            });

            self.participants = participantsToKeep;

            self.selectedWinnerParticipants = [];
        };

        self.toggleWinnerSelection = function (participantId) {
            let idx = self.selectedWinnerParticipants.indexOf(participantId);

            if (idx > -1) {
                self.selectedWinnerParticipants.splice(idx, 1);
            } else {
                self.selectedWinnerParticipants.push(participantId);
            }
        };

        self.addWinnerRule = function () {
            newRule = {};
            newRule.key = self.winnerKey;
            newRule.value = self.winnerValue;

            self.winnerKey = null;
            self.winnerValue = null;

            self.winnerRules.push(newRule);
        };

        self.removeWinnerRule = function (index) {
            self.winnerRules.splice(index, 1);
        };

        self.getPrizePools = function(){
            data = {};

            giftWithPurchaseService.getPrizePools(self.experienceId, data)
                .then(onGetPrizePools, onError);
        };

        let onGetPrizePools = function (data) {
            self.prizePools = data;
        };
        //END: SWEEPS WINNER DRAWING

        //START: REPORTING SECTION
        self.loadStats = function (giftWithPurchaseId, experienceStart, experienceEnd) {
            if (self.currentId == undefined) {
                self.currentId = giftWithPurchaseId;
            }

            if (self.reportingStartedAt == undefined) {
                self.reportingStartedAt = new Date(experienceStart);
                self.reportingEndedAt = new Date(experienceEnd);
            }

            giftWithPurchaseService.statsGiftWithPurchase(self.currentId, {
                start: self.reportingStartedAt.toISOString(),
                end: self.reportingEndedAt.toISOString(),
                report_name: 'stats',
                report_type: 'json'
            }).then(onStats, onError);
            // if (self.updateStats == undefined) {
            //     self.updateStats = $interval(self.loadStats, 2000);
            // }
            self.graphGiftWithPurchase();
        };

        let onStats = function (data) {
            self.stats = data.stats;
        };

        self.updateStats = function () {
            self.loadStats();
            $mdToast.show({
                hideDelay : 1500,
                position : 'bottom left',
                template : '<md-toast>' +
                    '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Date range updated!</span>' +
                    '</md-toast>'
            });
        };

        self.graphGiftWithPurchase = function () {
            giftWithPurchaseService.graphGiftWithPurchase(self.currentId)
                .then(onGraphGiftWithPurchase, onError);
        };

        let onGraphGiftWithPurchase = function (data) {
            self.graph.name = 'Overview Graph';
            self.graph.data = data.data;
            self.graph.labels = data.labels;
            self.graph.series = data.series;
        };
        //END: REPORTING SECTION

        // START: OFFLINE
        self.entered_at = new Date();
        self.postmarked_at = new Date();
        self.received_at = new Date();
        self.participantPopup = function (ev, participantId) {
            participantModalService.getParticipantModal(ev, participantId);
        };
        // END: OFFLINE

        //START ENTRY VALIDATION SECTION
        self.isEntrySubmitting = false;
        self.entry = {};
        self.personData = {};
        self.isPersonDataOpen = false;
        self.entryParticipantNotes = {};
        self.otherEntries = {};
        self.showIndex = 0;
        self.showValidationInstructions = true;
        self.showPrizePools = true;
        self.queueType = '';
        self.entryImageRotation = 0;
        self.rotationClass = '';
        self.showCompleteMessage = false;
        self.currentEntryImageIndex = 1;
        self.skip = 0;
        self.otherEntryImageRotation = 0;
        self.currentOtherEntryImageIndex = 1;

        self.lockTimeLeftDisplay = '--:--';
        self.lockTimeEndDisplay = '--:--';
        self.showPriorImageUseContainer = false;
        self.isReprocess = false;

        self.participantInfo = function(ev, participantId) {
            participantModalService.getParticipantModal(ev, participantId);
        };

        self.newEntryForValidation = function (experienceId, entry) {
            self.entry = entry;
            self.isLoading = true;
            self.submission = undefined;

            if(!entry) {
                giftWithPurchaseService.getNewEntryForValidation(experienceId, { type: self.queueType, skip: self.skip })
                    .then(onNewEntryForValdation, onError);
            } else {
                giftWithPurchaseService.getEntryForValidation(experienceId, entry)
                    .then(onNewEntryForValdation, onError);
            }
        };

        /**
         * Submission object defining function (constructor)
         */
        function Submission(giftWithPurchaseId, service, data) {
            this.giftWithPurchaseId = giftWithPurchaseId;
            this.service = service;
            this.raw = data;
            this.awarded_prizes = data.hasOwnProperty('awarded_prizes') ? data.awarded_prizes : [];
            this.credits = data.hasOwnProperty('credits') ? data.credits : {};
            this.entry = data.hasOwnProperty('entry') ? data.entry : {};
            this.entry.images = data.hasOwnProperty('images') ? data.images : {};
            this.lock = data.hasOwnProperty('lock') ? data.lock : {};
            this.lockTimeLeftDisplay = '--:--';
            this.lockTimeEndDisplay = '--:--';
            this.countdown = undefined;
            this.active_image_index = 0;
            this.others = data.hasOwnProperty('other_entries') ? data.other_entries : [];
            this.active_other_index = 0;
            this.active_other_image_index = 0;
            this.participant = data.hasOwnProperty('participant') ? data.participant : {};
            this.is_reprocess = false;
            this.cropperImage = undefined;
            let currentSubmission = this;

            this.hasEntry = function() {
                return Object.keys(this.entry).length > 0;
            };

            this.hasMultipleImages = function() {
                return !!(this.entry &&
                    this.entry.images &&
                    this.entry.images.constructor === Array &&
                    this.entry.images.length > 1);
            };

            this.getActiveImageUrl = function() {
                return this.entry.images[this.active_image_index] ?
                    this.entry.images[this.active_image_index].disk_url :
                    '';
            };

            this.rotateActiveImage = function(direction) {
                if (this.cropperImage) {
                    let rotation = direction === 'left' ? -90 : 90;
                    this.cropperImage.rotate(rotation);
                }
            };

            this.getPreviousImage = function () {
                if (this.entry.images[this.active_image_index - 1]) {
                    this.active_image_index--;
                }
            };

            this.getNextImage = function () {
                if (this.entry.images[this.active_image_index + 1]) {
                    this.active_image_index++;
                }
            };

            this.hasOtherMultipleEntries = function () {
                return !!(this.others &&
                    this.others.constructor === Array &&
                    this.others.length > 1);
            };

            this.hasOtherMultipleImages = function () {
                return !!(this.others[this.active_other_index] &&
                    this.others[this.active_other_index].images &&
                    this.others[this.active_other_index].images.constructor === Array &&
                    this.others[this.active_other_index].images.length > 1);
            };

            this.getOtherActiveImageUrl = function () {
                return this.others[this.active_other_index] &&
                this.others[this.active_other_index].images[this.active_other_image_index] ?
                    this.others[this.active_other_index].images[this.active_other_image_index].disk_url :
                    '';
            };

            this.getOtherActiveImageRotation = function () {
                if (this.others[this.active_other_index] &&
                    this.others[this.active_other_index].images[this.active_other_image_index]) {
                    return this.others[this.active_other_index].images[this.active_other_image_index].rotation;
                }
            };

            this.rotateOtherActiveImage = function (direction) {
                if (this.others[this.active_other_index] &&
                    this.others[this.active_other_index].images[this.active_other_image_index]) {
                    this.others[this.active_other_index].images[this.active_other_image_index].rotation = this.others[this.active_other_index].images[this.active_other_image_index].rotation ? this.others[this.active_other_index].images[this.active_other_image_index].rotation : 0;
                    this.others[this.active_other_index].images[this.active_other_image_index].rotation += (direction === 'left') ? 90 : -90;
                }
            };

            this.getOtherPreviousImage = function () {
                if (this.others[this.active_other_index].images[this.active_other_image_index - 1]) {
                    this.active_other_image_index--;
                }
            };

            this.getOtherNextImage = function () {
                if (this.others[this.active_other_index].images[this.active_other_image_index + 1]) {
                    this.active_other_image_index++;
                }
            };

            this.getOtherPreviousEntry = function () {
                if (this.others[this.active_other_index - 1]) {
                    this.active_other_index--;
                    this.getEntryFingerprints(this.others[this.active_other_index].entry);
                }
            };

            this.getOtherNextEntry = function () {
                this.active_other_image_index = 0;
                if (this.others[this.active_other_index + 1]) {
                    this.active_other_index++;
                    this.getEntryFingerprints(this.others[this.active_other_index].entry);
                }
            };

            this.getImageKeys = function(data) {
                return Object.keys(data).filter(function (value) {
                    return RegExp('^image_[0-9]+$').test(value);
                });
            };

            this.getImagesData = function (keys, data) {
                let imagesData = [];
                keys.forEach(function (key) {
                    let md5Key = key + '_md5';

                    if (data[key]) {
                        imagesData.push({
                            name: key,
                            url: data[key],
                            md5: data.hasOwnProperty(md5Key) ? data[md5Key] : undefined,
                            rotation: 0
                        });
                    }
                });

                return imagesData;
            };

            let LockModalController = function ($mdDialog) {
                let dCtrl = this;
                dCtrl.parentObject = currentSubmission;

                dCtrl.reset = function () {
                    dCtrl.parentObject.service
                        .postRelockEntry(dCtrl.parentObject.giftWithPurchaseId, dCtrl.parentObject.entry.eid)
                        .then(onRelock, onRelockError);
                };

                let onRelock = function (data) {
                    $interval.cancel(dCtrl.parentObject.countdown);
                    dCtrl.parentObject.startTimer(data.lock.seconds_left);
                    $mdDialog.cancel();
                    $mdToast.show({
                        hideDelay: 1500,
                        position: 'bottom left',
                        template: '<md-toast>' +
                            '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully reset lock!</span>' +
                            '</md-toast>'
                    });
                };

                let onRelockError = function (data) {
                    $mdDialog.cancel();
                    $mdToast.show({
                        hideDelay: 1500,
                        position: 'bottom left',
                        template: '<md-toast>' +
                            '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-close" aria-hidden="true"></i> An error occurred, please contact support.</span>' +
                            '</md-toast>'
                    });
                };

                dCtrl.hide = function () { $mdDialog.hide(); };

                dCtrl.cancel = function () { $mdDialog.cancel(); };
            };

            this.timer = function (seconds) {
                let submissionInstance = this;
                let then = Date.now() + seconds * 1000;
                this.displayTimeLife(seconds);
                this.displayEndTime(then);

                this.countdown = $interval(function () {
                    let secondsLeft = Math.round((then - Date.now()) / 1000);
                    // check if we should stop it
                    if (secondsLeft < 0) {
                        $interval.cancel(submissionInstance.countdown);
                        submissionInstance.lockTimeLeftDisplay = '0:00';
                        $window.location.href =  '/' + self.client_eid + '/experience/gift-with-purchase/' + submissionInstance.giftWithPurchaseId + '/validation';
                    } else {
                        // display it
                        submissionInstance.displayTimeLife(secondsLeft);

                        if (secondsLeft === 30) {
                            LockModalController.$inject = ['$mdDialog'];
                            $mdDialog.show({
                                controller: LockModalController,
                                controllerAs: 'lockModalController',
                                templateUrl: '/experience/gift-with-purchase/partials/entry-validation-lock-modal',
                                parent: angular.element(document.body),
                                clickOutsideToClose: true,
                                escapeToClose: true
                            });
                        }
                    }
                }, 1000);
            };

            this.deleteTimer = function () { $interval.cancel(this.countdown); };

            this.displayTimeLife = function (seconds) {
                let minutes = Math.floor(seconds / 60);
                let remainderSeconds = seconds % 60;
                this.lockTimeLeftDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
            };

            this.displayEndTime = function (timestamp) {
                let end = new Date(timestamp);
                let hour = end.getHours();
                let adjustedHour = hour > 12 ? hour - 12 : hour;
                let minutes = end.getMinutes();
                this.lockTimeEndDisplay = adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
            };

            this.startTimer = function (seconds) {
                this.timer(parseInt(seconds));
            };

            this.initializeCropper = function () {
                if (currentSubmission.cropperImage) {
                    currentSubmission.cropperImage.destroy();
                }
                currentSubmission.cropperImage = new Cropper(document.querySelector('#entryImage'), {
                    viewMode: 0,
                    dragMode: 'move',
                    autoCrop: false,
                    modal: false,
                    guides: false,
                    highlight: false
                });
            };

            this.getEntryFingerprints = function (entry) {

                experienceService.getExperienceParticipantFingerprint(
                    entry?.tether_pivot_id
                )
                    .then(
                        function(data) {
                            entry.fraudAnalyses = data;

                            data.forEach(function(fraud) {
                                if (fraud.fraud_status.name == 'duplicate' ||
                                    fraud.fraud_status.name == 'fuzzy_match') {
                                    
                                    entry.requires_fraud_check = true;
                                }
                            });
                        },
                        onError
                    );

            };

            this.initialize = function() {
                // Delete any existing timers
                $interval.cancel(this.countdown);

                // Convert data string to object
                if (this.entry.hasOwnProperty('data') && this.entry.data && this.entry.data.constructor === String) {
                    this.entry.data = JSON.parse(this.entry.data);
                }

                // Setup credits
                if (this.entry.hasOwnProperty('person_credits')) {
                    this.entry.credits = this.entry.person_credits ? this.entry.person_credits : 1;
                    this.entry.person_credits = this.entry.person_credits ? this.entry.person_credits : 1;
                }

                if (this.entry.hasOwnProperty('suggested_credits') && this.entry.suggested_credits) {
                    this.is_reprocess = true;
                }

                // Setup lock timer
                if (this.lock != null &&
                    Object.keys(this.lock).length > 0 &&
                    this.lock.hasOwnProperty('seconds_left') &&
                    this.lock.seconds_left != null) {
                    this.startTimer(this.lock.seconds_left);
                } else {
                    $interval.cancel(this.countdown);
                    this.lockTimeLeftDisplay = '--:--';
                    this.lockTimeEndDisplay = '--:--';
                }

                this.getEntryFingerprints(this.entry);

                if (this.others[this.active_other_index]) {
                    this.getEntryFingerprints(this.others[this.active_other_index].entry);
                }

            };

            this.initialize();
        }

        let onNewEntryForValdation = function (data) {
            if (data && data.hasOwnProperty('entry')) {
                self.submission = new Submission(self.giftWithPurchaseId, giftWithPurchaseService, data);
                self.isLoading = false;
            } else {
                $window.location.href = '/' + self.client_eid + '/experience/gift-with-purchase/' + self.giftWithPurchaseId + '/validation';
            }
        };

        self.submitEntryForValdation = function (
            experienceId,
            experienceParticipantId,
            status,
            reason,
            creditArray,
            partialReason,
            personCredits,
            noProcess,
            additionalInformation,
            humanReason
        ) {
            if (self.currentId === undefined) {
                self.currentId = experienceId;
            }

            let data = {
                experienceParticipantId: experienceParticipantId,
                status: status,
                reason: reason,
                creditArray: creditArray,
                partialReason: partialReason,
                personCredits: personCredits
            };

            if (status === 'kicked') {
                data.human_reason = humanReason;
            }

            if (noProcess === 1) {
                data.is_reprocess = true;
            }

            if (additionalInformation &&
                typeof additionalInformation === 'object' &&
                Object.keys(additionalInformation).length > 0) {
                data.additional_information = additionalInformation;
            }

            self.submission.deleteTimer();

            giftWithPurchaseService.postEntryForValidation(experienceId, data)
                .then(onSubmitEntryForValdation, onError);
        };

        let onSubmitEntryForValdation = function (data) {
            self.isEntrySubmitting = false;
            if (data.errors) {
                alert(data.errors[0]);
                if (data.hasOwnProperty('type') && data.type === 'awarded_prize_limit') {
                    self.newEntryForValidation(self.currentId);
                }
            } else {
                if (self.experienceParticipantId) {
                    self.showCompleteMessage = true;
                    self.entry = false;
                } else {
                    self.newEntryForValidation(self.currentId);
                }
            }

            self.submissionBrandsAndPackSizes = '';
            self.submissionQuantityOfQualifyingProducts = '';
            self.submissionTransactionDate = '';
            self.submissionTransactionTime = '';
            self.submissionTransactionPaymentType = '';
            self.submissionTransactionTotal = '';
            self.submissionRetailerName = '';
            self.submissionRetailerAddress1 = '';
            self.submissionRetailerAddress2 = '';
            self.submissionRetailerCity = '';
            self.submissionRetailerProvince = '';
            self.submissionRetailerPostalCode = '';
        };
        //END FUNCTIONS FOR SCROLLING THROUGH OTHER ENTRY IMAGES

        self.showNextKickedEntry = function (experienceId) {
            self.skip++;
            self.newEntryForValidation(experienceId);
        };

        self.showPreviousKickedEntry = function (experienceId) {
            if(self.skip - 1 <= 0) {
                self.skip = 0;
            } else {
                self.skip--;
            }
            self.newEntryForValidation(experienceId);
        };

        self.toggleValidationInstructions = function () {
            self.showValidationInstructions = !self.showValidationInstructions;
        };

        self.togglePrizePools = function () {
            self.showPrizePools = !self.showPrizePools;
        };

        self.getConfirmationModal = function(ev, experienceId, experienceParticipantId, status, $clientEid) {
            if(!self.submission.entry.credits) {
                self.submission.entry.credits = 1;
            }

            self.confirmationModalExperienceId = experienceId;
            self.confirmationModalExperienceParticipantId = experienceParticipantId;
            self.confirmationModalStatus = status;
            self.client_eid = $clientEid;

            ConfirmationModalController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ConfirmationModalController,
                controllerAs: 'confirmationModalController',
                templateUrl: route('client-prefix.experience.gift-with-purchase.partials.entry-validation-confirmation-modal', {
                    client: self.client_eid,
                    experience: self.confirmationModalExperienceId
                }),
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        let ConfirmationModalController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parentController = self;
            dCtrl.pools = self.pools;
            dCtrl.selectedReason = '';
            dCtrl.selectedReasons = {};
            dCtrl.status = self.confirmationModalStatus;
            dCtrl.validationReasons = [];
            dCtrl.validationPartialReasons = {};
            dCtrl.reason = '';
            dCtrl.partialReason = '';
            dCtrl.reasonErrors = [];
            dCtrl.pool = null;
            dCtrl.type = null;
            dCtrl.selectedPartialReason = '';
            dCtrl.selectedPartialReasons = {};
            dCtrl.validationPartialReasons = {};
            dCtrl.humanReason = '';
            dCtrl.submission = self.submission;
            dCtrl.personCredits = self.submission.entry.is_reprocessed ? self.submission.entry.suggested_credits : self.submission.entry.credits;
            dCtrl.credits = isNaN(parseInt(dCtrl.personCredits)) ? 1 : parseInt(dCtrl.personCredits);
            dCtrl.noProcess = self.submission.entry.is_reprocessed;
            dCtrl.creditArray = [];
            dCtrl.totalCredits = 0;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            if(dCtrl.status == 'invalid') {
                dCtrl.shouldBeDisabled = true;
            } else {
                dCtrl.shouldBeDisabled = false;
            }

            dCtrl.cancel = function () {
                angular.forEach(dCtrl.validationReasons, function(validationReason){
                    validationReason.selected = false;
                });

                angular.forEach(dCtrl.validationPartialReasons, function(validationPartialReason){
                    validationPartialReason.selected = false;
                });

                $mdDialog.cancel();
            };

            dCtrl.updateTypes = function (event) {
                dCtrl.types = [];
                let TypeFoundException = {};

                // Cheap hack to stop looping when prize pool is found to set
                // prize types. Using this as Array.prototype.find() is not
                // implemented for Internet Explorer
                try {
                    dCtrl.pools.forEach(function (pool) {
                        if (pool.id === dCtrl.pool) {
                            dCtrl.types = pool.prize_types;
                            throw TypeFoundException;
                        }
                    });
                } catch (exception) {
                    if (exception !== TypeFoundException) {
                        throw exception;
                    }
                }

                if (dCtrl.types.length == 1) {

                }
            };

            dCtrl.submitEntryForValdation = function () {
                dCtrl.parentController.isEntrySubmitting = true;
                dCtrl.reason = '';
                dCtrl.partialReason = '';
                dCtrl.reasonErrors = [];
                dCtrl.partialReasonErrors = [];
                dCtrl.errors = [];
                dCtrl.glue = '';

                angular.forEach(dCtrl.validationReasons, function(validationReason){
                    if(validationReason.selected) {
                        if(dCtrl.reason == '') {
                            dCtrl.glue = '';
                        } else {
                            dCtrl.glue = ',';
                        }
                        dCtrl.reason = dCtrl.reason + dCtrl.glue + validationReason.key;
                    }
                });

                angular.forEach(dCtrl.validationPartialReasons, function(validationPartialReason){
                    if(validationPartialReason.selected) {
                        if(dCtrl.partialReason == '') {
                            dCtrl.glue = '';
                        } else {
                            dCtrl.glue = ',';
                        }
                        dCtrl.partialReason = dCtrl.partialReason + dCtrl.glue + validationPartialReason.key;
                    }
                });

                dCtrl.personCredits = parseInt(dCtrl.personCredits);
                dCtrl.personCredits = isNaN(dCtrl.personCredits)
                    ? 0
                    : dCtrl.personCredits;
                dCtrl.credits = parseInt(dCtrl.credits);
                dCtrl.credits = isNaN(dCtrl.credits)
                    ? 0
                    : dCtrl.credits;

                // Error, invalid content, display error
                if (dCtrl.status === 'invalid' &&
                    (dCtrl.reason === undefined || dCtrl.reason === null || (typeof dCtrl.reason === 'string' && dCtrl.reason.trim().length === 0))) {
                    dCtrl.parentController.isEntrySubmitting = false;
                    dCtrl.reasonErrors.push('A reason is required for submission');
                } else if (dCtrl.status === 'kicked' &&
                    (dCtrl.humanReason === undefined || dCtrl.humanReason === null || (typeof dCtrl.humanReason === 'string' && dCtrl.humanReason.trim().length === 0))) {
                    dCtrl.parentController.isEntrySubmitting = false;
                    dCtrl.reasonErrors.push('A reason is required for submission');
                } else if (dCtrl.status === 'valid' && dCtrl.noProcess !== 1 && (dCtrl.personCredits > dCtrl.totalCredits) &&
                    (dCtrl.partialReason === undefined || dCtrl.partialReason === null || (typeof dCtrl.partialReason == 'string' && dCtrl.partialReason.trim().length === 0))) {
                    dCtrl.parentController.isEntrySubmitting = false;
                    dCtrl.partialReasonErrors.push('A reason is required for submission');
                } else if (dCtrl.status === 'valid' && dCtrl.creditArray.length == 0) {
                    dCtrl.parentController.isEntrySubmitting = false;
                    dCtrl.errors.push('Credits and prize information must be added');
                } else {
                    let additionalInformation = {};
                    if (dCtrl.submissionBanner) {
                        additionalInformation.banner = dCtrl.submissionBanner;
                    }
                    if (dCtrl.submissionBrandsAndPackSizes) {
                        additionalInformation.brands_and_pack_sizes = dCtrl.submissionBrandsAndPackSizes;
                    }
                    if (dCtrl.submissionQuantityOfQualifyingProducts) {
                        additionalInformation.quantity_of_qualifying_products = dCtrl.submissionQuantityOfQualifyingProducts;
                    }
                    if (dCtrl.submissionTransactionDate) {
                        additionalInformation.transaction_date = dCtrl.submissionTransactionDate;
                    }
                    if (dCtrl.submissionTransactionTime) {
                        additionalInformation.transaction_time = dCtrl.submissionTransactionTime;
                    }
                    if (dCtrl.submissionTransactionPaymentType) {
                        additionalInformation.transaction_payment_type = dCtrl.submissionTransactionPaymentType;
                    }
                    if (dCtrl.submissionTransactionTotal) {
                        additionalInformation.transaction_total = dCtrl.submissionTransactionTotal;
                    }
                    if (dCtrl.submissionRetailerName) {
                        additionalInformation.retail_name = dCtrl.submissionRetailerName;
                    }
                    if (dCtrl.submissionRetailerAddress1) {
                        additionalInformation.retailer_address_1 = dCtrl.submissionRetailerAddress1;
                    }
                    if (dCtrl.submissionRetailerAddress2) {
                        additionalInformation.retailer_address_2 = dCtrl.submissionRetailerAddress2;
                    }
                    if (dCtrl.submissionRetailerCity) {
                        additionalInformation.retailer_city = dCtrl.submissionRetailerCity;
                    }
                    if (dCtrl.submissionRetailerProvince) {
                        additionalInformation.retailer_province = dCtrl.submissionRetailerProvince;
                    }
                    if (dCtrl.submissionRetailerPostalCode) {
                        additionalInformation.retailer_postal_code = dCtrl.submissionRetailerPostalCode;
                    }
                    /*self.submitEntryForValdation(
                        self.confirmationModalExperienceId,
                        self.confirmationModalExperienceParticipantId,
                        self.confirmationModalStatus,
                        dCtrl.reason,
                        dCtrl.credits,
                        dCtrl.pool,
                        dCtrl.type,
                        dCtrl.partialReason,
                        dCtrl.personCredits,
                        dCtrl.noProcess,
                        additionalInformation,
                        dCtrl.humanReason
                    );*/

                    self.submitEntryForValdation(
                        self.confirmationModalExperienceId,
                        self.confirmationModalExperienceParticipantId,
                        self.confirmationModalStatus,
                        dCtrl.reason,
                        dCtrl.creditArray,
                        dCtrl.partialReason,
                        dCtrl.personCredits,
                        dCtrl.noProcess,
                        additionalInformation,
                        dCtrl.humanReason
                    );
                    dCtrl.cancel();
                    // self.modalOpen = true;
                }
            };

            dCtrl.addReason = function () {
                dCtrl.reasonErrors = [];
                if (dCtrl.selectedReason) {
                    angular.forEach(dCtrl.validationReasons, function(validationReason){
                        if(dCtrl.selectedReason == validationReason.key) {
                            validationReason.selected = true;
                        }
                    });

                    dCtrl.shouldBeDisabled = dCtrl.validationReasons.filter(v => v.selected).length == 0;
                }
            };

            dCtrl.addPartialReason = function () {
                dCtrl.partialReasonErrors = [];
                if (dCtrl.selectedPartialReason) {
                    angular.forEach(dCtrl.validationPartialReasons, function(validationPartialReason){
                        if(dCtrl.selectedPartialReason == validationPartialReason.key) {
                            validationPartialReason.selected = true;
                        }
                    });
                }
                dCtrl.shouldBeDisabled = dCtrl.validationPartialReasons.filter(v => v.selected).length == 0;
            };

            dCtrl.removeReason = function (key) {
                angular.forEach(dCtrl.validationReasons, function(validationReason){
                    if(key == validationReason.key) {
                        validationReason.selected = false;
                    }
                });
                dCtrl.shouldBeDisabled = dCtrl.validationReasons.filter(v => v.selected).length == 0;
            };

            dCtrl.removePartialReason = function (key) {
                angular.forEach(dCtrl.validationPartialReasons, function(validationPartialReason){
                    if(key == validationPartialReason.key) {
                        validationPartialReason.selected = false;
                    }
                });
                dCtrl.shouldBeDisabled = dCtrl.validationPartialReasons.filter(v => v.selected).length == 0;
            };

            dCtrl.addCredits = function(){
                dCtrl.errors = [];

                if(!dCtrl.credits || !dCtrl.pool || !dCtrl.type) {
                    return;
                }

                var prize_pool_name = '';
                var prize_type_name = '';

                    dCtrl.pools.forEach(function (currentPool) {
                        if (currentPool.id === dCtrl.pool) {
                            prize_pool_name = currentPool.name
                        }
                    });

                    dCtrl.types.forEach(function (currentType) {
                        if (currentType.id === dCtrl.type) {
                            prize_type_name = currentType.name
                        }
                    });

                dCtrl.creditArray.push(
                    {
                        "credits" : dCtrl.credits,
                        "prize_pool_id" : dCtrl.pool,
                        "prize_type_id" : dCtrl.type,
                        "prize_pool_name" : prize_pool_name,
                        "prize_type_name" : prize_type_name
                    }
                );

                dCtrl.totalCredits += dCtrl.credits;

                dCtrl.credits = null;
                dCtrl.pool = null;
                dCtrl.type = null;
            };

            dCtrl.removeCredits = function(index){
                dCtrl.totalCredits -= dCtrl.creditArray[index].credits;

                if (index > -1) {
                    dCtrl.creditArray.splice(index, 1);
                }
            };

            if (dCtrl.submission.entry.experience.name == 'GWP - Goldfish Summer Scooter') {
                dCtrl.targetPool = self.submission.entry.data.retailer ? self.submission.entry.data.retailer : null;
                if (dCtrl.targetPool) {
                    let p = dCtrl.pools.filter(e => e.name === dCtrl.targetPool)[0];
                    dCtrl.pool = p.id;
                    dCtrl.updateTypes();
                    if (p.prize_types.length == 1) {
                        dCtrl.type = p.prize_types[0].id;
                    }
                }
            }

            if (dCtrl.pools && dCtrl.pools.length === 1) {
                dCtrl.pool = dCtrl.pools[0].id;
                dCtrl.updateTypes();
                if (dCtrl.pools[0].prize_types && dCtrl.pools[0].prize_types.length === 1) {
                    dCtrl.type = dCtrl.pools[0].prize_types[0].id;
                }
            }
        };
        //END ENTRY VALIDATION SECTION

        // START: PRIZING
        self.indexPrizePool = function (experienceId) {
            giftWithPurchasePrizingService.index(experienceId)
                .then(onPrizePoolIndex, onPrizePoolIndexError);
        };

        let onPrizePoolIndex = function (data) {
            self.prizePools = data;
        };

        let onPrizePoolIndexError = function (data) {
            // Error.
        };

        self.indexPrizeType = function (experienceId, poolId) {
            giftWithPurchasePrizingService.indexType(experienceId, poolId)
                .then(onPrizeTypeIndex, onPrizeTypeIndexError);
        };

        let onPrizeTypeIndex = function (data) {
            self.prizePool = data;
            if (data.hasOwnProperty('prize_types')) {
                self.prizeTypes = data.prize_types;
            }
        };

        let onPrizeTypeIndexError = function (data) {
            // Error.
        };

        let ModalCreatePrizePoolController = function ($mdDialog) {
            let modalController = this;
            modalController.experienceId = self.modalCreatePrizePoolExperienceId;
            modalController.indexPrizePool = self.modalCreatePrizePoolIndexPrizePool;
            modalController.name;
            modalController.award_credit_threshold;
            modalController.errors = {};

            modalController.hide = function () {
                $mdDialog.hide();
            };

            modalController.cancel = function () {
                $mdDialog.cancel();
            };

            modalController.store = function () {
                giftWithPurchasePrizingService.store(modalController.experienceId, {
                    'name': modalController.name,
                    'award_credit_threshold': modalController.award_credit_threshold,
                    'is_testing': modalController.is_testing
                }).then(onStore, onStoreError);
            };

            let onStore = function (data) {
                modalController.cancel();
                modalController.indexPrizePool(modalController.experienceId);

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully created prize pool!</span>' +
                        '</md-toast>'
                });
            };

            let onStoreError = function (response) {
                if (response.hasOwnProperty('data')
                    && response.data.hasOwnProperty('errors')) {
                    modalController.errors = response.data.errors;
                }

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred please contact support!</span>' +
                        '</md-toast>'
                });
            };
        };

        self.openCreatePrizePoolModal = function (ev, experienceId, clientEid) {
            self.modalCreatePrizePoolExperienceId = experienceId;
            self.modalCreatePrizePoolIndexPrizePool = self.indexPrizePool;
            self.client_eid = clientEid;
            ModalCreatePrizePoolController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ModalCreatePrizePoolController,
                controllerAs: 'createPrizePoolController',
                bindToController: true,
                templateUrl: route('client-prefix.experience.gift-with-purchase.prize-pool.modal-create', {
                    client: self.client_eid
                }),
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
            });
        };

        let ModalEditPrizePoolController = function ($mdDialog) {
            let modalController = this;
            modalController.experienceId = self.modalEditPrizePoolExperienceId;
            modalController.prizePool = self.modalEditPrizePoolPrizePool;
            modalController.errors = {};

            modalController.hide = function () {
                $mdDialog.hide();
            };

            modalController.cancel = function () {
                $mdDialog.cancel();
            };

            modalController.update = function () {
                giftWithPurchasePrizingService.update(
                    modalController.experienceId,
                    modalController.prizePool.id,
                    {
                        name: modalController.prizePool.name,
                        award_credit_threshold: modalController.prizePool.award_credit_threshold
                    }
                ).then(onUpdate, onUpdateError);
            };

            let onUpdate = function (data) {
                modalController.cancel();

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully updated the prize pool!</span>' +
                        '</md-toast>'
                });
            };

            let onUpdateError = function (response) {
                if (response.hasOwnProperty('data')
                    && response.data.hasOwnProperty('errors')) {
                    modalController.errors = response.data.errors;
                }

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred please contact support!</span>' +
                        '</md-toast>'
                });
            };
        };

        self.openEditPrizePoolModal = function (ev, experienceId, prizePool, clientEid) {
            self.modalEditPrizePoolExperienceId = experienceId;
            self.modalEditPrizePoolPrizePool = prizePool;
            self.client_eid = clientEid;
            ModalEditPrizePoolController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ModalEditPrizePoolController,
                controllerAs: 'editPrizePoolController',
                bindToController: true,
                templateUrl: route('client-prefix.experience.gift-with-purchase.prize-pool.modal-edit', {
                    client: self.client_eid
                }),
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        let ModalCreatePrizeTypeController = function ($mdDialog) {
            let modalController = this;
            modalController.name;
            modalController.errors = {};
            modalController.experienceId = self.modalCreatePrizeTypeExperienceId;
            modalController.poolId = self.modalCreatePrizeTypePrizePoolId;
            modalController.indexPrizeType = self.modalCreatePrizeTypeIndexPrizeType;

            modalController.hide = function () {
                $mdDialog.hide();
            };

            modalController.cancel = function () {
                $mdDialog.cancel();
            };

            modalController.storeType = function () {
                giftWithPurchasePrizingService
                    .storeType(modalController.experienceId, modalController.poolId, { 'name': modalController.name })
                    .then(onStoreType, onStoreTypeError);
            };

            let onStoreType = function (data) {
                modalController.cancel();
                modalController.indexPrizeType(modalController.experienceId, modalController.poolId);

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully created a prize type!</span>' +
                        '</md-toast>'
                });
            };

            let onStoreTypeError = function (response) {
                if (response.hasOwnProperty('data')
                    && response.data.hasOwnProperty('errors')) {
                    modalController.errors = response.data.errors;
                }

                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred please contact support!</span>' +
                        '</md-toast>'
                });
            };
        };

        self.openCreatePrizeTypeModal = function (ev, experienceId, poolId, clientEid) {
            self.modalCreatePrizeTypeExperienceId = experienceId;
            self.modalCreatePrizeTypePrizePoolId = poolId;
            self.modalCreatePrizeTypeIndexPrizeType = self.indexPrizeType;
            self.client_eid = clientEid;
            ModalCreatePrizeTypeController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ModalCreatePrizeTypeController,
                controllerAs: 'createPrizeTypeController',
                bindToController: true,
                templateUrl: route('client-prefix.experience.gift-with-purchase.prize-pool.prize-type.modal-create', {
                    client: self.client_eid
                }),
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };
        // END: PRIZING

        // START: PRIZE POOL ACTIVITY
        self.prizePoolActivityPagination = undefined;
        self.prizePoolActivityCurrentPage = undefined;

        self.initializePrizePoolActivityPagination = function () {
            if (self.activities && self.activities.last_page) {
                self.prizePoolActivityCurrentPage = self.activities.current_page;
                self.prizePoolActivityPagination = range(1, self.activities.last_page);
            }
        };
        // END: PRIZE POOL ACTIVITY

        // START: PRIZE INDEX ACTIVITY
        self.prizeIndexPagination = undefined;
        self.prizeIndexCurrentPage = undefined;

        self.initializePrizeIndexPagination = function () {
            if (self.prizes && self.prizes.last_page) {
                self.prizeIndexCurrentPage = self.prizes.current_page;
                self.prizeIndexPagination = range(1, self.prizes.last_page);
            }
        };
        // END: PRIZE INDEX ACTIVITY

        //START: REJECTION REASONS
        self.showRejectionReasons = function(index){
            self.languageRejectionReasons[index].show = !self.languageRejectionReasons[index].show;
        };

        self.removeRejectionReason = function(index){
            self.giftWithPurchase.rejection_reason.splice(index, 1);

            angular.forEach(self.giftWithPurchase.rejection_reason, function(currentRejectionReason, index) {
                self.languageRejectionReasons[index] = {};
                self.languageRejectionReasons[index].show = false;
            });
        };

        self.addRejectionReason = function(){
            self.giftWithPurchase.rejection_reason.push(
                {
                    'name' : self.newRejectionReasonName,
                    'is_rejected_due_to_prize_limit_rejection_reason' : '',
                    'language_rejection_reason' : [
                        {
                            'text' : '',
                            'language' : {
                                'slug' : 'en'
                            }
                        },
                        {
                            'text' : '',
                            'language' : {
                                'slug' : 'fr'
                            }
                        }
                    ]
                }
            );

            self.newRejectionReasonName = '';

            angular.forEach(self.giftWithPurchase.rejection_reason, function(currentRejectionReason, index) {
                self.languageRejectionReasons[index] = {};
                self.languageRejectionReasons[index].show = false;
            });
        };

        //START: PARTICIPATING PRODUCTS
        self.showParticipatingProducts = function(index){
            self.participatingProducts[index].show = !self.participatingProducts[index].show;
        };
        self.addParticipatingProducts = function(){
            //collect the self.participating products when you save or save exit

            if (self.participatingProducts.find(product => product.eid == self.client_products[self.selected_product].eid) === undefined) {
                self.participatingProducts.push(
                    {
                        eid: self.client_products[self.selected_product].eid,
                        name: self.client_products[self.selected_product].name,
                        alias: {
                            en: self.client_products[self.selected_product].name,
                            fr: ""
                        },
                        show: false
                    }
                );
            }
        }

        self.removeParticipatingProducts = function(index){
            self.participatingProducts.splice(index, 1);
        };
        //END: PARTICIPATING PRODUCTS

        //START: EXPERIENCE EDIT TIMER

        self.getExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.giftWithPurchase.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.lock(lockData).then(initiateExperienceLock, onError);
        }

        self.extendExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.giftWithPurchase.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.extend(lockData).then(initiateExperienceLock, onError);
        };

        self.releaseExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.giftWithPurchase.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.release(lockData);
        };

        let initiateExperienceLock = function(modelLock) {
            self.modelLock = modelLock;
            self.experienceLockTimeEndDisplay = self.DisplayTime(modelLock.lock_expired_at);
            self.initiateExperienceLockCountdown(modelLock.seconds_left);
        };

        self.initiateExperienceLockCountdown = function (seconds) {
            let then = Date.now() + seconds * 1000;
            if (angular.isDefined(self.experienceLockCountdown)) {
                $interval.cancel(self.experienceLockCountdown);
                self.experienceLockCountdown = undefined
            }
            self.experienceLockCountdown = $interval(function () {
                let secondsLeft = Math.round((then - Date.now()) / 1000);
                if (secondsLeft < 0) {
                    self.experienceLockTimeRemainingDisplay = '0:00';
                    redirectToIndex();
                    $interval.cancel(self.experienceLockCountdown);
                } else {
                    let minutes = Math.floor(secondsLeft / 60);
                    let remainderSeconds = secondsLeft % 60;
                    self.experienceLockTimeRemainingDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
                    if (secondsLeft === 300) {
                        self.showExtendLock();
                    }
                }
            }, 1000);
        };

        self.DisplayTime = function(timestamp) {
            let end = new Date(timestamp);
            let hour = end.getHours();
            let adjustedHour = hour > 12 ? hour - 12 : hour;
            let minutes = end.getMinutes();
            return adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
        };

        self.showExtendLock = function() {
            var confirm = $mdDialog.confirm()
                  .title('Would you like to extend experience lock?')
                  .textContent('User will be redirected to index page without saving when timer runs out.')
                  .ariaLabel('Timer Dialog')
                  .ok('Extend Lock')
                  .cancel('Close');
            $mdDialog.show(confirm).then(function() {
                self.extendExperienceLock();
            }, function() {
                // this is close
            });
          };
        //END: EXPERIENCE EDIT TIMER

    }
]);


